export const CTransactionBadgeStates = {
    SUCCESSFUL: "successful",
    PROCESSING: "processing",
    FAILED: "failed",
} as const